import { generateUtilityClasses } from '@mui/material';

import type { ThemeOptions } from '@mui/material';
import type { ButtonBaseSize } from './constants';
import type { ButtonBaseProps } from './types';

declare module '@mui/material/Button' {
  interface ButtonPropsSizeOverrides
    extends Record<ButtonBaseSize, true>,
      Record<'small' | 'medium' | 'large', false> {}
}

declare module '@mui/material/styles' {
  interface ComponentsPropsList {
    ButtonBase: ButtonBaseProps;
  }
}

export const buttonBaseClasses = generateUtilityClasses('ButtonBase', ['root']);

// MuiButtonBase theme는 유지 (다른 컴포넌트에서도 사용)
export const buttonBaseThemes: ThemeOptions['components'] = {
  MuiButtonBase: {
    defaultProps: {
      // FIXME (@walter-24) 이렇게 지정 했지만 MuiButton을 직접 사용하는 곳에서만 동작하고, DropdownMenuOptionItem - MenuItem  - ButtonBase 간접적으로 사용되는 곳에서는 적용되지 않음
      disableRipple: true,
      disableTouchRipple: true,
    },
  },
  // ButtonBase의 styleOverrides와 variants는 컴포넌트 내부로 이전됨
};
